import {
  resetArcGisUser_actionType,
  resetAuthUser_actionType,
  setArcGisUser_actionType,
  setAuthUser_actionType,
  setEnterpriseUser_actionType,
  setUserRole_actionType,
} from "../constants";

export const setAuthUser = (payload) => ({
  type: setAuthUser_actionType,
  payload,
});

export const resetAuthUser = () => ({
  type: resetAuthUser_actionType,
});

export const setArcGisUser = (payload) => ({
  type: setArcGisUser_actionType,
  payload,
});

export const resetArcGisUser = () => ({
  type: resetArcGisUser_actionType,
});

export const setUserRole = (payload) => ({
  type: setUserRole_actionType,
  payload,
});

export const setEnterpriseUser = (payload) => ({
  type: setEnterpriseUser_actionType,
  payload,
});
